import type { FaireProductEntity } from "../../entity_types/product";

export const p_g25qayx8w4: FaireProductEntity = {
  token: "p_g25qayx8w4",
  type: "product",
  name: "Start & Finish Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5330cdc105eb632a93ae225e03835a2d9ff27953967f16c4a4fbf3b43b7aaebe.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b7f5875815b04a7fdc2c50519a6eab97c354671a73bdcc133d184a10d79fd2c.png",
    "https://cdn.faire.com/fastly/5292f96344937a2bdf4284a6c9a0ee6ea4b6b4de75863614288b3cb31a642eba.png",
    "https://cdn.faire.com/fastly/6c8c4b72fa7bba3d997b411b3c0a4d9061213b0e3c2a3cb8979c8e2829036f1f.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:57.552Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
